/**
 * Exchange rates for converting belt types to credits
 */
export const EXCHANGE_RATES = {
  coin: 0,
  bronze: 500,
  silver: 5000,
  gold: 50000,
  platinum: 500000,
};

/**
 * Sell rates for converting belt types to monetary value (in pounds)
 */
export const SELL_RATES = {
  coin: 0,
  bronze: 5,
  silver: 50,
  gold: 500,
  platinum: 5000,
};

export interface Stake {
  type: string;
  quantity: number;
}

export interface StakesValue {
  totalCredits: number;
  totalValue: number;
}

/**
 * Calculate total credits and monetary value based on stakes array
 * @param stakes - Array of stakes with type and quantity
 * @returns Object containing totalCredits and totalValue
 *
 * @example
 * const stakes = [
 *   { type: "Bronze", quantity: 2 },
 *   { type: "Silver", quantity: 1 }
 * ];
 * const result = calculateStakesValue(stakes);
 * // result = { totalCredits: 6000, totalValue: 60 }
 */
export const calculateStakesValue = (stakes: Stake[]): StakesValue => {
  let totalCredits = 0;
  let totalValue = 0;

  stakes.forEach((stake) => {
    const type = stake.type.toLowerCase();
    const quantity = stake.quantity || 0;

    totalCredits += (EXCHANGE_RATES[type] || 0) * quantity;
    totalValue += (SELL_RATES[type] || 0) * quantity;
  });

  return { totalCredits, totalValue };
};
